// src/utils/basemap.js
// One place that puts a basemap on a Leaflet map. Prefers a VECTOR style
// (MapLibre GL via the Leaflet adapter — crisp at any zoom and pixel density,
// which raster tiles never are on a 3× phone), falling back to raster tiles.
//
// Markers, polylines and the rest of the map code stay plain Leaflet.
import L from 'leaflet';
import 'maplibre-gl/dist/maplibre-gl.css';
import '@maplibre/maplibre-gl-leaflet'; // registers L.maplibreGL on this Leaflet instance

export function addBasemap(map, cfg = {}) {
  if (cfg.styleUrl && typeof L.maplibreGL === 'function') {
    try {
      return L.maplibreGL({
        style: cfg.styleUrl,
        interactive: false,           // Leaflet owns gestures
        attributionControl: false,
      }).addTo(map);
    } catch (e) {
      console.warn('Vector basemap failed, falling back to raster:', e);
    }
  }
  const opts = {
    attribution: cfg.tileAttribution,
    subdomains: cfg.tileSubdomains || 'abc',
    maxZoom: cfg.maxZoom || 19,
    maxNativeZoom: cfg.maxNativeZoom || cfg.maxZoom || 19,
    keepBuffer: 8,
    updateWhenIdle: false,
    updateInterval: 50,
  };
  const base = L.tileLayer(cfg.tileUrl, opts).addTo(map);
  if (cfg.labelsUrl) L.tileLayer(cfg.labelsUrl, { ...opts, pane: 'overlayPane' }).addTo(map);
  return base;
}
